export default {
  module: {
    name: 'cccyun-clogin-oauth',
  }
};
